export default "__VITE_ASSET__C1Nm0M4v__"